<template>
  <el-dialog
    title="用户编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="80px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="dataRight"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
// import {brequest} from '@/utils/brequest'
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    dataRight: Object
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '账号',
          field: 'loginName',
          type: 'text',
          disabled: true,
          rules: [{ required: true, message: '账户必填', trigger: 'blur' }]
        },
        {
          label: '权限类型',
          field: 'rightTypeTxt',
          type: 'text',
          disabled: true,
          rules: [{ required: true, message: '权限类型必填', trigger: 'blur' }]
        },
        {
          label: '权限内容',
          field: 'rightText',
          type: 'text',
          rules: [{ required: false, message: '用户姓名必填', trigger: 'blur' }]
        }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
